import { render, staticRenderFns } from "./NominationFormCreate.vue?vue&type=template&id=97ea7de6"
import script from "./NominationFormCreate.vue?vue&type=script&lang=js"
export * from "./NominationFormCreate.vue?vue&type=script&lang=js"
import style0 from "./NominationFormCreate.vue?vue&type=style&index=0&id=97ea7de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports